<template>
  <div class="home-page">
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "home",
  mounted() {
    if(!this.isAuthenticated) {
      this.$router.push({name: 'login'});
    } else {
      this.$router.push({name: 'dashboard'});
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated"])
  }
};
</script>
